import React from 'react';
import './CounterButton.scss';

export function CounterButton({ id, label, customClass = '', isSelected = false, onSelect }) {
  return (
    <button
      type="button"
      className={`${
        isSelected ? 'counter-btn-active ek-copy-16-semibold' : 'counter-btn ek-copy-16-medium'
      } ${customClass} rounded py-10 px-16 w-100`}
      onClick={() => onSelect(id)}>
      {label && <div className="btn-label">{label}</div>}
    </button>
  );
}

export default CounterButton;
